import getWestlakeApiObject from './getWestlakeApiObject';

export default getWestlakeApiObject;
